import { useEffect, useState } from 'react';
import Section from '../../components/NewApplication/Section';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import { GetApplicationManagementByID } from '../../_api';
// import ApiErrors from '../../components/NewApplication/ApiErrors';

import ApprovalsUpdate from './components/ApprovalsUpdate';
const UpdateApprovals = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [app, setApp] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	//on load, retrieve the AppManagementModel for the selected app
	useEffect(() => {
		GetApplicationManagementByID(appID)
			.then(response => {
				setApp(response);
			})
			.then(x => setIsLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<>
					<Section label='Update Approvals'>
						<ApprovalsUpdate
							appID={appID}
							currentUser={currentUser}
							app={app}
							readOnly={readOnly}
							requirementNumber={requirementNumber}
						/>
					</Section>
				</>
			)}
		</>
	);
};

export default UpdateApprovals;
